


function clickOutsideElement(callBack,overlayEl) {
    const overlay = overlayEl || '.nlx-js-invisible-overlay'
    const backgroundDOMElement = document.querySelector(overlay)

    const closeInvisibleOverlay = (event, callBack) => {
        if (event.target === backgroundDOMElement || event.key === 'Escape') {
            callBack()
            backgroundDOMElement.classList.remove('nlx-js-invisible-overlay--active')
        }
    }

    const displayInvisibleOverlay = () => {
        backgroundDOMElement.classList.add('nlx-js-invisible-overlay--active')
        backgroundDOMElement.addEventListener('click', (e) => closeInvisibleOverlay(e, callBack))
        window.addEventListener('keyup', (e) => closeInvisibleOverlay(e, callBack))
    }

    return displayInvisibleOverlay
}

export { clickOutsideElement }



